export default __webpack_public_path__ + "static/media/11_balcony.853da7a2.png";